// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero__HTO1t","link":"link__2Qkh4","section":"section__2f8jf","c":"c__1EsDJ","subtitle":"subtitle__1MDQG","image":"image__-d6mX","buttons":"buttons__1yBKT"};